/**
 * axios의 url에 parameter를 처리해줍니다.
 * ex) get('/api/get/{id}', { urlParam: { id: '1234' } }) -> GET /api/get/1234
 * @param {AxiosInstance} axios
 */
module.exports = function install_axios_url_params(axios) {
  if (axios.extension_url_params) {
    return;
  }
  axios.extension_url_params = true;

  axios.interceptors.request.use(config => {
    // process path params
    config.originalUrl = config.url;
    if (config.urlParams) {
      config.url = config.originalUrl.replace(/{[^}]+}/g, matched => {
        const paramName = matched.substring(1, matched.length - 1);
        const value = config.urlParams[paramName];
        if (value != null) {
          // return value
          return `${value}`.replace(/[{}]/g, '_');
        }
        return `UNKNOWN_PARAM_${paramName}`;
      });
    }
    return config;
  });
  // console.log(`axios extension injected: url-params`);
};
